export class EligibilityCheck {
    private readonly creditAssessmentId: string;

    constructor(assessmentId?: string) {
        this.creditAssessmentId = assessmentId;
    }

    public static from(eligibilityCheckJson: any): EligibilityCheck {
        const eligibilityCheck = new EligibilityCheck();
        Object.assign(eligibilityCheck, eligibilityCheckJson);
        return eligibilityCheck;
    }

    public getCreditAssessmentId() {
        return this.creditAssessmentId;
    }
}
